import { defineMessages } from 'react-intl';
import type { NoMessageValues } from 'react-intl';

export const wishlistMessages = defineMessages<{
  readonly removeSuccess: { readonly productName: string };
  readonly removeError: { readonly productName: string };
  readonly addSuccess: { readonly productName: string };
  readonly addError: { readonly productName: string };
  readonly removeLabel: NoMessageValues;
  readonly addLabel: NoMessageValues;
  readonly ariaRemove: NoMessageValues;
  readonly ariaAdd: NoMessageValues;
  readonly removeTitle: { readonly productName: string };
  readonly addTitle: { readonly productName: string };
}>({
  removeSuccess: {
    id: 'add-to-wishlist.remove-success',
    defaultMessage:
      '{productName, select, undefined {Der Artikel} other {{productName}}} wurde erfolgreich vom Merkzettel entfernt.',
  },
  removeError: {
    id: 'add-to-wishlist.remove-error',
    defaultMessage:
      '{productName, select, undefined {Der Artikel} other {{productName}}} konnte nicht vom Merkzettel entfernt werden.',
  },
  addSuccess: {
    id: 'add-to-wishlist.add-success',
    defaultMessage:
      '{productName, select, undefined {Der Artikel} other {{productName}}} wurde dem Merkzettel hinzugefügt.',
  },
  addError: {
    id: 'add-to-wishlist.add-error',
    defaultMessage:
      '{productName, select, undefined {Der Artikel} other {{productName}}} konnte nicht auf dem Merkzettel gespeichert werden.',
  },
  removeLabel: {
    id: 'add-to-wishlist.label.remove',
    defaultMessage: 'Vom Merkzettel entfernen',
  },
  addLabel: {
    id: 'add-to-wishlist.label.add',
    defaultMessage: 'Auf den Merkzettel',
  },
  ariaRemove: {
    id: 'add-to-wishlist.aria.remove',
    defaultMessage: 'Artikel vom Merkzettel entfernen',
  },
  ariaAdd: {
    id: 'add-to-wishlist.aria.add',
    defaultMessage: 'Artikel zum Merkzettel hinzufügen',
  },
  removeTitle: {
    id: 'add-to-wishlist-title.remove',
    defaultMessage:
      '{ productName, select, undefined { Der Artikel } other {{ productName }}} vom Merkzettel entfernen',
  },
  addTitle: {
    id: 'add-to-wishlist-title.add',
    defaultMessage:
      '{productName, select, undefined { Der Artikel } other {{ productName }}} auf den Merkzettel legen',
  },
});
